import React from "react";
import { Layout } from "../../components/layout";

import loadGif from "../../accets/images/gif/loader/loader.gif";

import "./LeapGaming.scss";

const LeapGaming = () => {
  return (
    <Layout
      containerStyles={
        "virtual-sports page-full-size hide-tab-navigation-footer-mobile compact-footer"
      }
      navHeader={"leapgaming"}
    >
      <div className="bc-loader medium full">
        <div className="bc-loader-contain">
          <img src={loadGif} alt="" />
        </div>
      </div>
    </Layout>
  );
};

export { LeapGaming };
